export default {
  INACTIVE: 'INACTIVE',
  ACTIVE: 'ACTIVE',
  BANNED: 'BANNED',
  REJECTED: 'REJECTED',
  INVITATION_PENDING: 'INVITATION_PENDING',
};
